export default "__VITE_ASSET__02ae2c45__"